module.exports = __webpack_public_path__ + "cy.svg?bb01eb742c8b8c12c73b6ae9cd9d7732";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/cy.svg
// module id = 1037
// module chunks = 27